import React from 'react'

const Metrics = () => {
  return (
    <div>Metrics</div>
  )
}

export default Metrics